import React, { Component } from 'react';
import { FormicaTimePickerDate } from './TimePickerDomain';
import DefaultTimePickerContainer from './DefaultTimePickerContainer';
import LanguageUtil from '../../../util/LanguageUtil';

class DatePickerDefaultSelectComponent extends Component<Props> {
  public render() {
    const { startDate, endDate, setStartDate, setEndDate, onApply, roundVisible } = this.props;
    return (
      <div className={'grid grid-cols-2 divide-x divide-[#E0E4E8] w-full h-full'}>
        <div className={'flex w-full h-full col-span-1 px-2 py-2'}>
          <DefaultTimePickerContainer type={'Start Date'} date={startDate} setDate={setStartDate} onApply={onApply} roundVisible={roundVisible} />
        </div>
        <div className={'flex w-full h-full col-span-1 px-2 py-2'}>
          <DefaultTimePickerContainer type={'End Date'} date={endDate} setDate={setEndDate} onApply={onApply} roundVisible={roundVisible} />
        </div>
        <div
          onClick={() => this.props.onApply(startDate, endDate)}
          className={'flex items-center justify-center text-sm cursor-pointer w-full col-span-2 h-9 rounded bg-primary text-white'}
          data-testid='date_picker_apply_button'
        >
          {LanguageUtil.get({ id: 'common.label.apply', defaultMessage: 'Apply' })}
        </div>
      </div>
    );
  }
}

interface Props {
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
  setStartDate(date: FormicaTimePickerDate): void;
  setEndDate(date: FormicaTimePickerDate): void;
  onApply: (startDate: FormicaTimePickerDate, endDate: FormicaTimePickerDate) => void;
  roundVisible?: boolean;
}

export default DatePickerDefaultSelectComponent;
